import { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './RatingStars.css';

const RatingStars = ({ rating }) => {
	const [ starArr, setStarArr ] = useState();

	useEffect(
		() => {
			if (rating) {
				const fullStars = Math.floor(rating);

				const tempStarArr = [];

				for (let i = 1; i <= fullStars; i++) {
					tempStarArr.push(1);
				}

				if (rating < 5) {
					const partialStar = rating - fullStars;

					tempStarArr.push(partialStar);

					const emptyStars = 5 - tempStarArr.length;

					for (let i = 1; i <= emptyStars; i++) {
						tempStarArr.push(0);
					}
				}

				setStarArr(tempStarArr);
			}
		},
		[ rating ]
	);

	return (
		<Fragment>
			{starArr &&
				starArr.length &&
				starArr.map((val, i) => {
					return (
						<i
							className="fa-solid fa-star rating-star"
							key={i}
							style={{
								backgroundImage      : `linear-gradient(to right, #fcbc05 ${val * 100}%, #cccccc ${val *
									100}%)`,
								WebkitBackgroundClip : 'text',
								backgroundClip       : 'text',
								WebkitTextFillColor  : 'transparent'
							}}
						/>
					);
				})}
		</Fragment>
	);
};

export default RatingStars;
